import React, { useEffect, useState, useRef } from "react";
import "./SuccessModal.scss";

const SuccessModal = ({
  open = false,
  title = "Опубліковано",
  subtitle = "Ваш контент доступний у стрічці",
  onComplete,
  autoCloseMs = 3000,
  disappearMs = 380,
}) => {
  const [visible, setVisible] = useState(open);
  const [active, setActive] = useState(false);
  const autoTimerRef = useRef(null);
  const leaveTimerRef = useRef(null);

  useEffect(() => {
    if (open) {
      setVisible(true);
      const raf = requestAnimationFrame(() => setActive(true));
      return () => cancelAnimationFrame(raf);
    }
    if (!open && visible) {
      startSoftClose();
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    clearTimeout(autoTimerRef.current);
    autoTimerRef.current = setTimeout(() => {
      startSoftClose();
    }, Math.max(600, autoCloseMs));
    return () => clearTimeout(autoTimerRef.current);
  }, [open, autoCloseMs]);

  const startSoftClose = () => {
    setActive(false);
    clearTimeout(leaveTimerRef.current);
    leaveTimerRef.current = setTimeout(() => {
      onComplete?.();
      setVisible(false);
    }, disappearMs);
  };

  useEffect(() => {
    return () => {
      clearTimeout(autoTimerRef.current);
      clearTimeout(leaveTimerRef.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`success-modal__backdrop ${active ? "open" : ""}`}
      role="dialog"
      aria-modal="true"
    >
      <div className={`success-modal__card ${active ? "open" : ""}`}>
        <div className="success-modal__check">
          <svg viewBox="0 0 72 72" width="88" height="88" aria-hidden="true">
            <circle className="ring" cx="36" cy="36" r="30" />
            <path
              className="tick"
              d="M22 37 L32 47 L50 26"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className="success-modal__title">{title}</div>
        {subtitle && <div className="success-modal__subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default SuccessModal;
